/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Segmentation_Failed18Inputs */

const en_us2_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your outline couldn't be separated from the background. Use a plain background that contrasts with your clothes, good light without backlight, and tight clothing.`)
};

const pt_br2_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para separar o contorno do corpo do fundo. Use um fundo liso que contraste com a roupa, boa luz sem contraluz e roupa justa.`)
};

const es_419_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo separar tu contorno del fondo. Usa un fondo liso que contraste con tu ropa, buena luz sin contraluz y ropa ajustada.`)
};

const pt_pt2_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível separar o contorno do corpo do fundo. Usa um fundo liso que contraste com a roupa, boa luz sem contraluz e roupa justa.`)
};

const fr_fr2_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de séparer ta silhouette du fond. Utilise un fond uni qui contraste avec tes vêtements, une bonne lumière sans contre-jour et des vêtements moulants.`)
};

const de_de2_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Umriss ließ sich nicht vom Hintergrund trennen. Nutz einen schlichten Hintergrund, der sich von deiner Kleidung abhebt, gutes Licht ohne Gegenlicht und eng anliegende Kleidung.`)
};

const it_it2_body_assessment_error_segmentation_failed18 = /** @type {(inputs: Body_Assessment_Error_Segmentation_Failed18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile separare la tua sagoma dallo sfondo. Usa uno sfondo uniforme che contrasti con gli abiti, buona luce senza controluce e abiti aderenti.`)
};

/**
* | output |
* | --- |
* | "Your outline couldn't be separated from the background. Use a plain background that contrasts with your clothes, good light without backlight, and tight clot..." |
*
* @param {Body_Assessment_Error_Segmentation_Failed18Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_segmentation_failed18 = /** @type {((inputs?: Body_Assessment_Error_Segmentation_Failed18Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Segmentation_Failed18Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_segmentation_failed18(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_segmentation_failed18(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_segmentation_failed18(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_segmentation_failed18(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_segmentation_failed18(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_segmentation_failed18(inputs)
	return en_us2_body_assessment_error_segmentation_failed18(inputs)
});
export { body_assessment_error_segmentation_failed18 as "body-assessment.error.SEGMENTATION_FAILED" }